//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CashCategoryDisplayItem } from './CashCategoryDisplayItem';

export class PayeeDisplayItem extends ItemBase {
    Payee: string | null = null;
    Category: CashCategoryDisplayItem | null = null;

    constructor(initializer?: Partial<PayeeDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PayeeDisplayItem";
}
